/* repeat.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
        <polygon class="foreground-gl" points="9.31 9.96 5 14.71 5 5.22 9.31 9.96"/>
        <polygon class="foreground-gl" points="12.89 9.96 8.57 14.71 8.57 5.22 12.89 9.96"/>
        <polygon class="foreground-gl" points="16.57 9.96 12.25 14.71 12.25 5.22 16.57 9.96"/>
        <path class="foreground-gl" d="M10,19.86a9.9,9.9,0,1,1,9.9-9.9A9.91,9.91,0,0,1,10,19.86ZM10,1.44A8.52,8.52,0,1,0,18.5,10,8.53,8.53,0,0,0,10,1.44Z" transform="translate(-0.08 -0.05)"/>
        </svg> 
    `
};
